import React from "react";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "~/components/ui/select";

interface PaymentMethodFilterProps {
  value?: string;
  onValueChange: (value: string | undefined) => void;
}

const PAYMENT_METHODS = [
  { value: "all", label: "Todos los métodos" },
  { value: "transfer", label: "Transferencia bancaria (Manual)" },
  { value: "bank_transfer", label: "Transferencia bancaria (Fintoc)" },
  { value: "cash", label: "Efectivo" },
  { value: "check", label: "Cheque" },
  { value: "factoring", label: "Factoring" },
  { value: "descuento_nomina", label: "Descuento nómina" },
  { value: "rappel", label: "Rappel" },
  { value: "webpay", label: "Webpay" },
  { value: "khipu", label: "Khipu" },
  { value: "fintoc", label: "Fintoc" },
  { value: "getnet", label: "GetNet" },
  { value: "manual", label: "Manual" },
  { value: "other", label: "Otro" },
];

const PaymentMethodFilter: React.FC<PaymentMethodFilterProps> = ({
  value,
  onValueChange,
}) => {
  const handleValueChange = (newValue: string) => {
    if (newValue === "all") {
      onValueChange(undefined);
    } else {
      onValueChange(newValue);
    }
  };

  return (
    <div>
      <Select value={value || "all"} onValueChange={handleValueChange}>
        <SelectTrigger className="w-[200px]">
          <SelectValue placeholder="Seleccionar método" />
        </SelectTrigger>
        <SelectContent>
          {PAYMENT_METHODS.map((method) => (
            <SelectItem key={method.value} value={method.value}>
              {method.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default PaymentMethodFilter;
